
import { AppBar, Box, Container, Grid, Toolbar, Typography, Radio, RadioGroup, FormControlLabel, Checkbox, Button, Snackbar, Alert, Dialog, DialogContent, DialogActions, useTheme, useMediaQuery, TextField } from '@mui/material';
import { InputPersonalizado, InputPersonalizadoGrande, InputPersonalizadoTelefono } from "../../components/InputPersonalizado";
import BasicModal from "./Modal";
import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { infoGlobal } from "../../api/infoGlobal";
import React from "react";
import "./style.css";
import { onboardingTarjetasApi } from "../../api/onboardingTarjetas";
import { useLocation } from "react-router-dom";
import visaImage from './../../assets/visa.png';

let keyReCaptcha = '';

interface infoSnack {
    open: boolean;
    message: string;
}

interface TarjetaImagen {
    id: number;
    nombre: string;
    imagen: string; // Base64
}

const infoSnackDafault = {
    open: false,
    message: ''
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function Inicio() {
    const [documento, setDocumento] = React.useState<string>("");
    const [dnn, setDnn] = React.useState<string>("");
    const [telefono, setTelefono] = React.useState<string>("");
    const [monto, setMonto] = React.useState<number>();
    const [montoStr, setMontoStr] = React.useState<string>("");
    const [codigoReferido, setReferido] = React.useState<string>(infoGlobal.GetReferido());
    const [openSnack, setopenSnack] = React.useState<infoSnack>(infoSnackDafault);
    const [checked, setChecked] = React.useState<boolean>(false)
    const [captchaIsDone, setCaptchaIsDone] = React.useState<boolean>(false);
    const [openTerminos, setOpenTerminos] = React.useState<boolean>(false);
    const [terminos, setTerminos] = React.useState<string>('');
    const tarjetas = infoGlobal.GetConfigTarjetas();
    const [imagenesTarjetas, setImagenesTarjetas] = React.useState<TarjetaImagen[]>([]);
    const [loadingImagenes, setLoadingImagenes] = React.useState<boolean>(true);
    const [isMasterChecked, setIsMasterChecked] = React.useState(tarjetas === 1 || tarjetas === 3);
    const [isVisaChecked, setIsVisaChecked] = React.useState(tarjetas === 2 || tarjetas === 3);

    keyReCaptcha = infoGlobal.GetKeyReCaptcha();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const esBCSAWEB = queryParams.get("esBCSAWEB");
    let codigoReferido_ = queryParams.get("codigoReferido");
    const utmParams: Record<string, string> = {};
    queryParams.forEach((value, key) => {
        if (key.startsWith("utm")) {
            utmParams[key] = value;
        }
    });

    if(codigoReferido_ === null || codigoReferido_ === undefined || codigoReferido_ === ""){
        codigoReferido_ = codigoReferido;
    }
    
    useEffect(() => {
        const allParams: Record<string, string> = {};
        queryParams.forEach((value, key) => {
            allParams[key] = value;
        });
        
        if (Object.keys(allParams).length > 0) {
            sessionStorage.setItem('queryParams', JSON.stringify(allParams));
        }
    }, [location.search]);

    useEffect(() => {
            onboardingTarjetasApi.GetTerminos().then((response) => {
                setTerminos(response.data.datos.datos);
            }).catch((error) => {
                setopenSnack({ open: true, message: 'Hubo un error al cargar los terminos y condiciones' });
            });

            onboardingTarjetasApi.GetImagenesTarjetas(codigoReferido_).then((response) => {
                console.log("la img es: "+response.data.datos.imagenes);
                setImagenesTarjetas(response.data.datos.imagenes || []);
            }).catch((error) => {
                setopenSnack({ open: true, message: 'Hubo un error al cargar los productos' });
            }).finally(() => {
                setLoadingImagenes(false);
            });
    }, []);

    const handleOpenTerminos = () => setOpenTerminos(true);
    const handleCloseTerminos = () => setOpenTerminos(false);

    const handleDocumento = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDocumento(event.target.value);
    };

    const handleDdn = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDnn(event.target.value);
    };

    const handleTelefono = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTelefono(event.target.value);
    };

    const handleChangeConfirmarTerminos = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    }

    const handleMontoStr = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const rawValue = e.target.value;
        if (rawValue === "") {
            setMontoStr("");
            setMonto(undefined);
            return;
        }
        const filteredValue = rawValue.replace(/[^0-9.,]/g, '');
        if (filteredValue === "" && rawValue !== "") {
            return;
        }
        setMontoStr(filteredValue);
        const normalized = filteredValue.replace(',', '.');
        const parsed = parseFloat(normalized);
        setMonto(isNaN(parsed) ? undefined : parsed);
    };

    function onChangeCaptcha() {
        setCaptchaIsDone(true);
    }

    const handleCloseSnack = () => { setopenSnack({ open: false, message: '' }) };

    const theme = useTheme();
    const isPantallaGrande = useMediaQuery(theme.breakpoints.up('lg'));

    const handleVisaChange = () => {
        if (tarjetas === 3) {
            setIsVisaChecked(!isVisaChecked);
        }
    };

    const handleMasterChange = () => {
        if (tarjetas === 3) {
            setIsMasterChecked(!isMasterChecked);
        }
    };

    const renderTarjetas = () => {
        if (loadingImagenes) {
            return (
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '200px' }}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography variant="body1" color="text.secondary">
                            Cargando productos...
                        </Typography>
                    </Box>
                </Grid>
            );
        }

        if (!imagenesTarjetas || imagenesTarjetas.length === 0) {
            return (
                <Grid item xs={12} display="flex" justifyContent="center">
                    <Box
                        component="img"
                        src={visaImage}
                        alt="VISA"
                        sx={{ width: "15%", height: "15%", my: 2 }}
                    />
                </Grid>
            );
        }

        return imagenesTarjetas.map((tarjeta, index) => {
            const imagenTarjeta = tarjeta || '';
            return (
                <Grid item xs={6} sm={4} display="flex" justifyContent="center" key={index}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Box
                            component="img"
                            src={`data:image/png;base64,${imagenTarjeta}`}
                            alt={`Producto ${index + 1}`}
                            sx={{ 
                                width: '185px', 
                                height: '265px', 
                                mb: 0,
                                objectFit: 'fill'
                            }}
                        />
                    </Box>
                </Grid>
            );
        });
    };

    const getProducto = () => {
        if (isMasterChecked && !isVisaChecked) return 1;
        if (!isMasterChecked && isVisaChecked) return 2;
        if (isMasterChecked && isVisaChecked) return 3; 
        return 0;
    };

    const renderMonto = () => {
        if(esBCSAWEB != null){
            return(
                <Grid item xs={4}>
                    <InputPersonalizado valueLabel="Monto" placeholderValue="123456789" onChange={handleMontoStr} value={montoStr}></InputPersonalizado>
                </Grid>
            )
        }
    }

    return (
        <>
            <Dialog open={openTerminos} onClose={handleCloseTerminos} maxWidth='lg' fullWidth>
                <DialogContent>
                    <Grid container direction='column' alignItems='center' justifyContent='center'>
                        <Grid item>
                            <div dangerouslySetInnerHTML={{ __html: terminos }}></div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button sx={{ borderRadius: 0 }} color='primary' variant='contained' type='button' onClick={handleCloseTerminos}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            <Box sx={{ width: 500 }}>
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={openSnack.open}
                    onClose={handleCloseSnack}
                    autoHideDuration={6000}
                    key={"top" + "center"}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {openSnack.message}
                    </Alert>
                </Snackbar>
            </Box>
            <Container maxWidth="md" sx={{ bgcolor: '#FFFFFF', p: 2, mt: 4 }}>
                <Grid item xs={12} textAlign={"center"}>
                    <h1 className="titulo">¡Bienvenido a Banco Columbia!</h1>
                    <Typography style={{ fontWeight: 'bold', marginBottom: "0px" }}>Estas a punto de solicitar una tarjeta de crédito.</Typography>
                    <Typography style={{ fontWeight: 'bold', marginTop: "0px" }}>Simple y rapido</Typography>
                </Grid>

                <Grid item xs={12}>
                    <p>Necesitamos identificarte:</p>
                </Grid>
                <Grid item xs={4}>
                    <InputPersonalizadoGrande value={documento} placeholderValue="123456789" onChange={handleDocumento} valueLabel="Documento" />
                </Grid>
                <Grid item xs={8}>
                    <InputPersonalizadoTelefono
                        ddn={dnn}
                        telefono={telefono}
                        valueLabel="Teléfono Celular"
                        onChangeDdn={handleDdn}
                        onChangeTelefono={handleTelefono}
                    />
                </Grid>
                {/* Caja de texto monto */}
                {renderMonto()}

                {/* Selección de tarjetas */}
                <Grid item xs={12}>
                    {tarjetas === 3 ? (
                        <p>Selecciona alguna tarjeta o ambas:</p>
                    ) : (
                        <p>Está por solicitar:</p>
                    )}
                </Grid>
                <Grid container spacing={0} justifyContent="center" alignItems="center">
                    {renderTarjetas()}
                </Grid>

                {/* Aceptación de términos y condiciones */}
                <Grid item xs={12} mt={5}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox
                            checked={checked}
                            onChange={handleChangeConfirmarTerminos}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        <Typography>
                            Al continuar acepta los <span className="terminosYcondiciones" onClick={handleOpenTerminos}>TERMINOS Y CONDICIONES</span>
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 10 }}>
                    <ReCAPTCHA sitekey={keyReCaptcha} onChange={onChangeCaptcha} />
                </Grid>
                <Grid item xs={12} textAlign={"center"} justifyContent="center" >
                    <BasicModal
                        dni={documento}
                        dnn={dnn}
                        celular={telefono}
                        producto={getProducto()}
                        codigoReferido={codigoReferido_}
                        esBCSAWEB={esBCSAWEB ?? ""}
                        monto={monto ?? 0}
                        utmParams={utmParams}
                        onStateSnack={setopenSnack}
                        setCelular={setTelefono}
                        checked={checked}
                        captchaIsDone={captchaIsDone}
                        isVisaChecked={isVisaChecked}
                        isMasterChecked={isMasterChecked}
                        tarjetas={tarjetas}
                    />
                </Grid>
            </Container>
        </>
    )
}

export default Inicio;